/**
 * @file   src\Pages\ScannerQue.tsx
 * @brief  Scanner queue / wash queued status page.
 * @date   JUL, 2026
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Button, useNavigate, useParams, useLocation } from "../utils/thirdpartyComponents";
import { pageURLs } from 'src/utils/pageUrls';
import "src/styles/inner-page-styles.scss";
import Advertisement from "./Advertisement";
import { bayTypeLabelMap, EquipmentTypeId } from "src/utils/enums";
import statusQueuedImg from "src/assets/images/status-queued-img.svg";

const ScannerQue = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const washName = location?.state?.washName;
  const bayName = location?.state?.bayName;
  const bayNumber = location?.state?.bayNumber;
  const bayTypeID = location?.state?.bayTypeID;
  const bayNameText = location?.state?.bayNameText;

  const OkbuttonClick = () => {
    navigate("/" + params.carwashname + "/" + pageURLs.home);
  };

  function getBayLabel(bayName: string, bayNumber: number, bayTypeID: number): any {
    if (bayName) return bayName;
    if (bayTypeID && bayNumber) {
      return `${bayTypeLabelMap[bayTypeID] || "Unknown"} ${bayNumber}`;
    }
    return "Unknown";
  }

  return (
    <div className="common-content-wrap pb-115">
      <div className="inner-content-wrap signup-block">
        <div className="common-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">Bay Status</div>
          </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
          <div className="scanner-status-wrap position-relative">
            <div className="bay-title d-flex flex-column">
              <p className="fw-bold m-0">Bay name: {bayNameText ? bayNameText : getBayLabel(bayName, bayNumber, bayTypeID)}</p>
              <p className="fw-bold m-0">{bayTypeID == EquipmentTypeId.Vacuum ? "Vacuum name" : "Wash name"}: {washName}</p>
            </div>
            <div className="status-img-wrap">
              <img src={statusQueuedImg} alt="Wash queued" />
            </div>
            <h2>Your wash is queued!</h2>
            <p>
              <strong>Payment confirmed.</strong>
              <br />
              Your wash will start automatically as soon as the current wash is complete.
              <br />
              Thank you for your patience.
            </p>
          </div>
        </div>
      </div>
      <div className="btm-wrap">
        <div className="btm-inner-wrap">
          <Button variant="primary" className="primary-btn btn-main" onClick={OkbuttonClick}>OK</Button>
        </div>
      </div>

      <Advertisement />
    </div>
  );
};

export default ScannerQue;
